// removed by extract-text-webpack-plugin
module.exports = {"bar":"styles-bar--3BK7E"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TimelineBar/styles.scss
// module id = DRnN
// module chunks = 3